import "./EstatePlanningProbate.module.css";
import EstatePlanningHero from "./sections/EstatePlanningHero";
import Footer from "@/reusable_sections/Footer";
import CoreEstateDocuments from "./sections/CoreEstateDocuments";
import ConsultationPreparation from "./sections/ConsultationPreparation";
import AssetAndContinuityEducation from "./sections/AssetAndContinuityEducation";
import ProbateGuidance from "./sections/ProbateGuidance";
import ConsultationCTA from "./sections/ConsultationCTA";
import Mainheader from "./sections/Mainheader";
export default function EstatePlanningProbatePage() {
  return <div>
      <Mainheader />
      <EstatePlanningHero />
      <CoreEstateDocuments />
      <ConsultationPreparation />
      <AssetAndContinuityEducation />
      <ProbateGuidance />
      <ConsultationCTA />
      <Footer />
    </div>;
}